import {AbsctractValidator} from "./AbstractValidator";

export class FullNameValidator extends AbsctractValidator {
    constructor(input, length) {
        super(input);
        this.length = length;
    }
    isValid() {
        return this.input.split(" ").length > 1 && this.input.split(" ")[1].length > 0;
    }
    message() {
        return !this.isValid() ? "Você deve preencher com seu nome completo" : "OK";
    }
}


// WEBPACK FOOTER //
// ./src/validator/FullNameValidator.js